import ApiConfig from "../config/Api.config";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";

const url = `${ApiConfig.URLBase}/pais`

const listar = async (): Promise<Response> => {
    
    const request: Request = {
        url: `${url}/listar`,
        metodo: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};


const PaisService = {
    listar,
};

export default PaisService;